<div class="min-h-full scroll-auto">
  <header-component/>
  <div class="h-full mt-20 w-full">
    <router-outlet/>
  </div>
  <footer-component/>
</div>
<toasts/>
<new-version-banner/>
